import React, { Component } from "react";
import { Layout, Breadcrumb, Row, Col } from "antd";
import HomeCard from "./HomeCard";

import IconPatient from "../../components/iconsScv/IconPatient";
import IconVisualizationCapacity from "../../components/iconsScv/IconVisualizationCapacity";
import IconReporting from "../../components/iconsScv/IconReporting";

import "./Home.css";

const { Content } = Layout;

class Home extends Component {
  render() {
    return (
      <Content
        style={{
          margin: "24px 16px",
          padding: 24,
          minHeight: 280,
        }}
      >
        <Breadcrumb style={{ padding: 24 }}>
          <Breadcrumb.Item>Accueil</Breadcrumb.Item>
        </Breadcrumb>
        <div
          className="site-layout-background mt-4"
          style={{ padding: 24, minHeight: 360 }}
        >
          <Row>
            <Col span={8} className="pr-4">
              <HomeCard
                title="Enregistrement Séjour"
                icon={<IconPatient />}
                link="/surgical_intervention"
                event="create_intervention"
              />
            </Col>
            <Col span={8} className="pr-4">
              <HomeCard
                title="Visualisation"
                icon={<IconVisualizationCapacity />}
                link="/calendar"
                event="show_calendar"
              />
            </Col>
            <Col span={8} className="pr-4">
              <HomeCard
                title="Reporting"
                icon={<IconReporting />}
                link="/daily_occupation_chart"
                event="show"
              />
            </Col>
          </Row>
        </div>
      </Content>
    );
  }
}

export default Home;